import { apiSlice } from "../../app/api/apiSlice";

export const lockExtensionCostCalculationApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		lockExtensionCostCalculation: builder.mutation({
			query: (body) => ({
				url: "/api/v1/loan/get_ob_lock_extension_cost_calculation/",
				method: "POST",
				body: body,
			}),
		}),
	}),
});

export const { useLockExtensionCostCalculationMutation } = lockExtensionCostCalculationApiSlice;

